import { AxiosResponse } from "axios";
import { api, CustomAxiosRequestConfig, ENDPOINTS } from "@app/api";

export type AcrossGroupMachineRow = {
  machineId: string;
  customerMachineName: string;
  serialNumber: string;
  modelAndType: string;
  pictureUrl: string | null;
  machineManufacturerName: string;
  machineTypeName: string;
  isFavourite?: boolean;
};

export type AcrossGroupMachinesGroup = {
  groupId: string;
  groupName: string;
  machines: AcrossGroupMachineRow[];
};

export type AcrossGroupMachinesResponse = {
  data: {
    groups: AcrossGroupMachinesGroup[];
    machinesCount: number;
    machines: string;
  };
  meta: Record<string, unknown>;
};

export const apiAcrossGroupMachines = (
  search: string,
): Promise<AxiosResponse<AcrossGroupMachinesResponse>> => {
  return api.get(ENDPOINTS.acrossGroupMachinesMachines, {
    params: { search },
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};
